import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import App from './App/App';
import { Button } from 'semantic-ui-react';
import { login, handleAuthentication, setSession } from './utils/auth';
import { loginRequest, loginError, loginSuccess } from './App/authReducer';
import history from './history';
import store from './store';
import { initialiseFirebase } from './firebase';

import loading from './assets/loading.svg';
import logo from './assets/logo.svg';

const authCallback = ({ location }) => {
  if (/access_token|id_token|error/.test(location.hash)) {
    handleAuthentication(async (err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        await initialiseFirebase(authResult.accessToken);
        const userProfile = setSession(authResult);
        store.dispatch(loginSuccess(userProfile));
      } else if (err) {
        store.dispatch(loginError(err));
      }
      history.push('/')
    });
  }
};

const Loading = () => (
  <div className="centre-gif">
    <img src={loading} alt="loading" />
  </div>
);

const Routes = ({ isFetching, isAuthenticated, error, onLoginClick }) => {
  return (
    <Router history={history}>
      <Switch>
        <Route path="/auth/signed-in" render={props => {
            if (!isAuthenticated) authCallback(props);
            return <Loading />;
          }}
        />
        <Route path="/" render={props => {
            if (isFetching) return <Loading />;

            return isAuthenticated ? (
              <App {...props} />
            ) : (
              <div className="home-noauth flex-vertical" onClick={onLoginClick}>
                <img src={logo} alt="Staker - login" />
                {error && <p>{error.errorDescription}</p>}
                <Button basic color="blue">
                  Login to Alpha
                </Button>
              </div>
            );
          }}
        />
      </Switch>
    </Router>
  );
};

const mapStateToProps = ({ auth }) => ({
  isAuthenticated: auth.isAuthenticated,
  isFetching: auth.isFetching,
  error: auth.error
});

const mapDispatchToProps = dispatch => ({
  onLoginClick() {
    dispatch(loginRequest());
    login();
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);



// WEBPACK FOOTER //
// ./src/routes.js